import type { CareEnvironment } from '../../appModel';
import { usesFamilyCaregivingStep } from '../../careEnvironmentCapabilities';
import { isNullOrUndefined } from '../../isNullOrUndefined';

interface PhaseFamilyCareHoursInput {
  familyCareHoursProvided: number;
  phaseCareHoursNeeded: number;
  careEnvironment: CareEnvironment;
  familyCareShare: number | undefined;
  useClaimProjectionEngine: boolean;
}

/**
 * The family's care hours for one phase. A custom family share replaces the family members'
 * own hours with that share of the phase's care, but only where family caregiving applies;
 * facility phases bundle care into their rate, so family provides none there.
 */
export function phaseFamilyCareHours({
  familyCareHoursProvided,
  phaseCareHoursNeeded,
  careEnvironment,
  familyCareShare,
  useClaimProjectionEngine,
}: PhaseFamilyCareHoursInput): number {
  if (isNullOrUndefined(familyCareShare)) return familyCareHoursProvided;
  if (!usesFamilyCaregivingStep(careEnvironment, useClaimProjectionEngine)) return 0;
  return Math.round(phaseCareHoursNeeded * familyCareShare);
}
